import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { stageListing } from "../services/apiService";

const Stages = (props) => {
  const companyId = props.companyId;
  const [stage, setStageList] = useState([]);
  const navigate = useNavigate();

  const fetchStage = async (id) => {
    try {
      const stageData = await stageListing("api/v1/stages/" + id);
      if (stageData && stageData.length > 0) {
        let newStageList = [];
        stageData.map((item, index) => {
          let defaultClass = "multisteps-form__progress-btn ";
          item.className = item.completed
            ? defaultClass + " js-active"
            : defaultClass;
          switch (item.stageName) {
            case "BUSINESS_REGISTRATION":
              item.labelName = "Registration";
              break;
            case "CONTENT_UPDATE":
              item.labelName = "Contents";
              break;
            case "TEMPLATE_SELECTION":
              item.labelName = "Template";
              break;
            case "DOMAIN_SELECTION":
              item.labelName = "Domain";
              break;
            case "WEBSITE_LIVE":
              item.labelName = "Live";
              break;
            case "PAYMENT_COMPLETION":
              item.labelName = "Payment";
              break;
            default:
              item.labelName = item.stageName;
              break;
          }

          newStageList.push(item);
        });

        setStageList(newStageList);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  const stageAction = (stageName) => {
    if(stageName=='Template') {
      navigate("/templateSelection");
    }
  }

  useEffect(() => {
    if (companyId != "") {
      fetchStage(companyId);
    }
  }, [companyId]);

  return (
    <div>
      {stage.length > 0 && (
        <div className="content text-center">
          <div className="content text-center">
            <div className="row">
              <div className="content text-center">
                <div className="row">
                  <div className="col-12 col-lg-8 mx-auto mb-4">
                    <div className="multisteps-form__progress d-flex flex-wrap justify-content-center">
                      {stage.map((item, index) => (
                        <>
                          <button
                            id={index}
                            key={index}
                            href="#"
                            onClick={(e) => stageAction(item.labelName)}
                            className={item.className}
                            title={item.labelName}
                          >
                            Step {index + 1}. {item.labelName}{" "}
                            {item.completed && (
                              <span key={index}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-check"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                                </svg>
                              </span>
                            )}
                          </button>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stages;
